import { useMutation, useQuery } from "@apollo/client/react";
import { toast } from "sonner";
import { gql } from "../__generated__";

const MESSAGE_REVIEWS_QUERY = gql(`
  query AssistantMessageReviews($conversationId: UUID!) {
    assistantMessageReviews(conversationId: $conversationId) {
      id
      messageId
      rating
      comment
      reviewerName
      isOwn
    }
  }
`);

const REVIEW_MESSAGE_MUTATION = gql(`
  mutation AssistantReviewMessage($messageId: UUID!, $rating: Int!, $comment: String) {
    assistantReviewMessage(messageId: $messageId, rating: $rating, comment: $comment) {
      id
    }
  }
`);

/** The reviews of a chat's answers, and saving the viewer's own. */
export function useAnswerReviews(conversationId: string) {
  const { data, refetch } = useQuery(MESSAGE_REVIEWS_QUERY, {
    variables: { conversationId },
    fetchPolicy: "cache-and-network",
  });
  const [review] = useMutation(REVIEW_MESSAGE_MUTATION, {
    onCompleted: () => void refetch(),
    onError: () => {
      toast.error("Bewertung konnte nicht gespeichert werden");
    },
  });
  const reviews = data?.assistantMessageReviews ?? [];

  return {
    reviewsOf: (messageId: string) => reviews.filter((r) => r.messageId === messageId),
    save: (messageId: string, rating: number, comment: string) =>
      void review({ variables: { messageId, rating, comment } }),
  };
}
